import React from "react";
import { XPosition, YPosition } from "../components/CoverPhoto";
import CoverPhoto from "../components/CoverPhoto";
import Headline from "../components/Headline";
import { css } from "emotion";

import TwoColumn from "../components/TwoColumn";
import TextCard from "../components/Cards/TextCard";
import ImageCard from "../components/Cards/ImageCard";
import TestimonyCard from "../components/Cards/TestimonyCard";
import StaffGenderBreakdownCard from "../components/Cards/StaffGenderBreakdownCard";
import FinancialAidBarChart from "../components/Cards/FinancialAidBarChart";
import EthnicityBreakdownBarChartCard from "../components/Cards/EthnicityBreakdownBarChartCard";
import EthnicitySectionBreakdownBarChartCard from "../components/Cards/EthnicitySectionBreakdownBarChartCard";
import InternEthnicityBreakdownBarChartCard from "../components/Cards/InternEthnicityBreakdownBarChartCard";
import InternGenderBreakdownBarChartCard from "../components/Cards/InternGenderBreakdownBarChartCard";
import GeographicBreakdownLineChartCard from "../components/Cards/GeographicBreakdownLineChartCard";
import TransferStatus from "../components/Cards/TransferComparison";
import AcademicBreakdownBarChartCard from "../components/Cards/AcademicBreakdownBarChartCard";
import LGBTQBreakdownPieChartCard from "../components/Cards/LGBTQBreakdownPieChartCard";
import DisabilityBreakdownPieChartCard from "../components/Cards/disabilityBreakdownPieChartCard"
import VeteranBreakdownPieChartCard from "../components/Cards/veteranBreakdownPieChartCard"

import { mediaQueries, colors, fonts } from "../shared/config";
interface PageState {
  query: any;
}

const link_style= `
  color: ${colors.darkblue}; 
  text-decoration: none; 
  
  "&:hover": {text-decoration: underline}
  `

export default class Page extends React.Component<{ data: any }, PageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      query: null
    };
  }

  componentDidMount() {
    fetch(
      "https://kerckhoff.dailybruin.com/api/packages/flatpages/diversityreport.fall2023",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(results => results.json())
      .then(results => this.setState({ query: results }));
  }
  
  getCaption(item){
    let cap = [];
    let i=0;
    while (item.caption[i]){
      // console.log(item.value.caption[i].value)
      cap.push(<br/>);
      cap.push(item.caption[i].value);
      cap.push(<br/>);
      ++i
    }
    // console.log(cap);
    return cap;
  }

  getIntro(item){
    let intro = [];
    let i=0;
    while (item[i]){
      // console.log(item.value.caption[i].value)
      if (item[i].value.charAt(0)  === '*'){
        intro.push(<ul><li>{item[i].value.substring(1)}</li></ul>)
      }
      else if (i === 3){
        intro.push(<br/>)
        intro.push('We have continued to publish special packages of writing and multimedia works for ')
        intro.push(<a href = "https://dailybruin.com/tag/hispanic-heritage-month-2022" target = "_blank">Hispanic Heritage Month</a>)
        intro.push(', ')
        intro.push(<a href = "https://dailybruin.com/tag/native-american-heritage-month-2022" target = "_blank"> Native American Heritage Month</a>) 
        intro.push(' and ')
        intro.push(<a href = "https://features.dailybruin.com/2023/bhm-2023/" target = "_blank">Black History Month </a>)
        intro.push('to highlight stories in these communities. We adjusted the details and format of these packages to be less focused on digital presentation and direct more effort towards ensuring the quality of their stories.')
        intro.push(<br/>)
      }
      else if (i === 17){
        intro.push(<br/>)
        intro.push('While this year’s report does not indicate any significant increases in our diversity across several categories, we are continually working to improve. We also welcome your ideas and suggestions for improving this report. Please contact us via social media, email, or submit an op-ed/letter to the editor at ')
        intro.push(<a href = "https://dailybruin.com/submit" target = "_blank">dailybruin.com/submit</a>)
        intro.push('.')
        intro.push(<br/>)
      }
      else if ( i=== 20){
        intro.push(<br/>)
        intro.push('Data about UCLA’s demographics is collected from data provided on ')
        intro.push(<a href = "www.ucla.edu" target = "_blank">www.ucla.edu</a>)
        intro.push(' and from records requests to the university. When this report was compiled in January 2023, data was not yet available for the 2022-2023 academic year, so this report uses data from the 2021-2022 academic year.')
        intro.push(<br/>)
      }
      else {
        intro.push(<br/>);
        intro.push(item[i].value);
        intro.push(<br/>);
        console.log(typeof(item[i].value))
      }
      ++i
    }
    return intro;
  }
  

  render() {
    const { mobile, notMobile } = mediaQueries;
    if (!this.state.query) return <></>;
    const data = this.state.query.data["site.aml"];
    //console.log(data);
    //console.log(data.coverPhoto);
    // console.log(data.introText.introBlurb);
    return (
      <>
        {this.props.data && (
          <div
            className={css`
              justify-content: center;
              font-family: sans-serif;
              font-family: ${fonts.textFont};
            `}
          >
            <CoverPhoto
              headline={data.coverTitle}
              description={data.coverBlurb}
              imageURL={data.CoverPhoto}
              darken={0.4}
            />

            <Headline text={data.introTitle} content={data.introBlurb} />

            <article
              className={css`
                margin-left: auto;
                margin-right: auto;
                margin-top: 0;
                max-width: 700px;
                padding: 1rem;
                text-align: justify;
                font-family: sans-serif;
                font-family: ${fonts.textFont};
              `}
            >
             {/* {this.getIntro(data.introText.introBlurb)} */}
             For the fifth consecutive year, the Daily Bruin reflects on its progress toward becoming a more diverse and representative source of journalism for the UCLA community.
             <br/><br/>
             One of the Daily Bruin’s fundamental goals is to share the stories of the UCLA community and its diversity through our coverage. But paramount to this goal is ensuring our own newsroom staff represents the student body. Just as the Daily Bruin seeks to create transparency about UCLA administration, we also must do so for ourselves. We hope this report can provide insight into the makeup of our staff, initiatives we have taken this year to improve coverage of underrepresented groups,  and, most importantly, our shortcomings and plans to move forward.
             <br/><br/>
             Here are actions we have taken to improve diversity at The Bruin this year:
             <br/>
             <ul>
              <li>Created an Equity, Diversity and Inclusion Committee that meets once a month to reflect on our EDI goals and areas for improvement in our coverage</li>
              <li>Reinstated EDI training for editors, including workshops on transfer student awareness, covering diverse communities and assessing the Daily Bruin’s culture</li>
              <li>Adjusted requirements to become a paid staffer as a transfer student to facilitate faster pathways to leadership positions across the paper</li>
             </ul>
             The Daily Bruin stopped producing heritage month packages in 2023 due to feedback that packages could appear tokenizing and merely fill quotas of diverse coverage. Instead, the staff worked to increase coverage of cultural groups on campus year-round. Around culturally significant events, such as <a href="https://dailybruin.com/tag/lunar-new-year-2024">Lunar New Year</a>, leadership continued to encourage coverage from both content and multimedia sections.
             <br/><br/>
             The Daily Bruin won a second-place organizational Pinnacle Award, distributed by the College Media Association, recognizing its diversity initiatives during the 2022-2023 school year. To be considered for the award, The Bruin submitted the <a href="https://features.dailybruin.com/2023/diversity-report-2022-2023/">2022-2023 diversity report</a>, a long-term article on the UC’s proposed <a href="https://features.dailybruin.com/2022/ethnic-studies-longterm/">ethnic studies requirement</a>,  feedback from our annual retention survey organized by Outreach and an introductory essay, among other projects.
             <br/><br/>
             The Daily Bruin Outreach section, established four years ago, has continued its efforts to recruit a more diverse group of students at UCLA, gather community input and understand our needs internally. This past year, they have accomplished the following:<br/>
             <ul>
              <li>Found new community leaders and initiated events for DB affinity group Transfers-of-DB</li>
              <li>Presented about The Bruin and college journalism to local community colleges and high schools to extend outreach to the greater Los Angeles community, generating feedback about our coverage and outreach strategies</li>
              <li>Created an intern package to help integration of new interns</li>
              <li>Continued surveying intern and staff needs and concerns through internal retention surveys</li>
              <li>Reached out to and engaged with clubs and organizations representing underrepresented groups as well as academic departments to recruit interns from diverse backgrounds and learn how to cover their communities </li>
              <li>Strengthened connections with the Transfer Student Center and Black Bruin Resource Center through tabling at events like Transferpalooza, Transfer Mingle, and Black Excellence Fair </li>
              <li>Started a community events calendar to keep track of more events happening around campus</li>
             </ul>
             Changes from last year’s report:
             <ul>
              <li>Sent the survey at the end of winter quarter to include interns hired in winter quarter in survey responses</li>
             </ul>
             While this year’s report does not indicate any significant increases in our diversity across several categories, we are continually working to improve. We also welcome your ideas and suggestions for improving this report. Please contact us via social media or email, or submit an op-ed/letter to the editor at <a href="https://dailybruin.com/submit">dailybruin.com/submit</a>.<br/><br/>
             About the Data:<br/><br/>
             Data about Daily Bruin staff was collected through a survey sent during winter quarter. All visualizations and analysis are representative of the data collected in winter. Staff members self-identify their answers to every question, and the data is collected anonymously. A total of 289 responses were collected this year. Last year, 216 responses were collected.<br/><br/>
             Data about UCLA’s demographics is collected from data provided on <a href="https://www.ucla.edu/about/facts-and-figures">ucla.edu</a> and from records requests to the university. This report uses data from the 2023-2024 academic year, with the most recent updated data from January 2024.

            </article>
            <TwoColumn>
              {data.layout.map((item: any, i: number) => {
                // console.log(item);
                switch (item.type) {
                  case "image":
                    return <ImageCard value={item.value} />;
                  case "text":
                    return <TextCard text={item.value} />;
                  case "testimony":
                    return <TestimonyCard value={item.value} />;
                  case "genderBreakdown":
                    return <StaffGenderBreakdownCard caption={this.getCaption(item.value)}/>;
                  case "financialAidBreakdown":
                    return <FinancialAidBarChart caption={this.getCaption(item.value)}/>;
                  case "geographicBreakdown":
                    return <GeographicBreakdownLineChartCard caption={this.getCaption(item.value)}/>;
                  case "ethnicityBreakdown":
                    return <EthnicityBreakdownBarChartCard caption = {this.getCaption(item.value)}/>;
                  case "transferStatus":
                    return <TransferStatus caption={this.getCaption(item.value)}/>;
                  case "LGBTQBreakdown":
                    return <LGBTQBreakdownPieChartCard caption={this.getCaption(item.value)}/>;
                  case "disabilityBreakdown":
                    return <DisabilityBreakdownPieChartCard caption={this.getCaption(item.value)}/>;
                  case "veteranBreakdown":
                    return <VeteranBreakdownPieChartCard caption={this.getCaption(item.value)}/>;
                  default:
                    return <></>;
                }
              })}
            </TwoColumn>
            <div
              className={css`
                width: 70%;
                ${mobile} {
                  width: 100%;
                }
                margin: 0 auto;
              `}
            >
              {data.academicBreakdown && 
                <AcademicBreakdownBarChartCard caption={this.getCaption(data.academicBreakdown)}/>
              }
              {data.ethnicitySectionBreakdown && 
                <EthnicitySectionBreakdownBarChartCard caption={this.getCaption(data.ethnicitySectionBreakdown)}/>
              }
            </div>
            <div>
              <h1
                className={css`
                  font-family: sans-serif;
                  font-family: ${fonts.textFont};
                  font-size: 48px;
                  align-items: center;
                  text-align: center;
                  font-weight: 300;
                  margin: 0 10px;
                  margin-top: 80px;
                  color: #3d3d3d;
                `}
              >
                A Look at intern classes from 2019 to 2023
              </h1>

              <TwoColumn>
                <InternEthnicityBreakdownBarChartCard caption={this.getCaption(data.internEthnicityBreakdown)}/>
                <InternGenderBreakdownBarChartCard caption={this.getCaption(data.internGenderBreakdown)}/>
              </TwoColumn>
            </div>
            <Headline text={data.analysisTitle} content={data.analysisBlurb} />
            <Headline text={data.outroTitle} content={data.outroBlurb} />
            <article
            className={css`
            margin-left: auto;
            margin-right: auto;
            margin-top: 0;
            margin-bottom: 0;
            max-width: 700px;
            padding: 1rem;
            text-align: justify;
            font-family: sans-serif;
            font-family: ${fonts.textFont};
            p {
              line-height: 1.0; // Adjust this value to change the line spacing
            }
          `}>
            Sincerely,<br/><br/>
            <p>
              Isabelle Friedman<br /><br />
              <em>2023-2024 Editor in chief</em>
            </p>
            <p>
              Junwon Choi<br /><br />
              <em>2023-2024 Data editor</em>
            </p>
            <p>
              Neeti Badve<br /><br />
              <em>2023-2024 Outreach director</em>
            </p>
            </article>
            <div
              className={css`
                height: auto;
                text-align: center;
                padding: 10px;
                background-color: ${colors.lightgray};
              `}
            >
              Analysis by Junwon Choi, Data editor. Developed by Junwon Choi, Data editor and Daily Bruin staff. Design by Daily Bruin staff.
            </div>
          </div>
        )}
      </>
    );
  }
}
